import { useContext } from "react";
import { useTranslation } from "react-i18next";
import { AuthContext } from "../../context/AuthContext";
import { PRICING_OPEN } from "../../config/features";

export default function MyPageSidebar({ activeTab, onChangeTab }) {
  const { t } = useTranslation();
  const { user } = useContext(AuthContext);
  const name = user?.username || user?.email?.split("@")[0] || "";
  const initial = (name || user?.email || "?").charAt(0).toUpperCase();

  const item = (key, label) => (
    <button
      key={key}
      className={activeTab === key ? "active" : ""}
      onClick={() => onChangeTab(key)}
    >
      {label}
    </button>
  );

  return (
    <aside className="mypage-sidebar">
      <div className="mp-side-profile">
        <span className="mp-avatar">{initial}</span>
        <div className="mp-side-profile-text">
          <b>{name}</b>
          <small title={user?.email}>{user?.email}</small>
        </div>
      </div>

      <nav className="sidebar-menu">
        <div className="sidebar-group-label">{t("mypage.sidebar.groupWork")}</div>
        {item("drive", t("mypage.sidebar.drive"))}
        {item("gallery", t("mypage.sidebar.gallery"))}

        <div className="sidebar-group-label">{t("mypage.sidebar.groupAccount")}</div>
        {item("account", t("mypage.sidebar.account"))}
        {PRICING_OPEN && item("storage", t("mypage.sidebar.payment"))}
      </nav>
    </aside>
  );
}
